import type { RootState } from '@src/store/reduxstore';

export const audioRecordingSelector = (state: RootState) =>
  state.agentConsole.audioRecording;

export default audioRecordingSelector;
